/** Stays on the Workflow route until Leo rules on a route file (spec needs_leo 1). */
export const ACTION_PLAN_PATH = "/portal/workflow" as const;

export const actionPlanItemId = (key: string): string => `item-${key}`;

/** `?b=id,id`, the building filter; the page reads it and its one URL writer writes it. */
export const B_KEY = "b";

/** `<Link>` props. `#item-<key>` opens the item. */
export const actionPlanLink = (buildingId?: string, key?: string) => ({
  to: ACTION_PLAN_PATH,
  search: buildingId ? { [B_KEY]: buildingId } : {},
  hash: key ? actionPlanItemId(key) : undefined,
});

/** `?law=` opens a law's tab; with `?building=` a building in LL33's. The page reads both; its URL writer and ll33BoardLink write them. */
export const LAW_KEY = "law";
export const BUILDING_KEY = "building";
/** LL33's `?law=`. */
export const LL33_LAW = "ll33";

/** "See all buildings" on the LL33 card: the phase 2 board, this row highlighted. */
export const ll33BoardLink = (buildingId: string) => ({
  to: ACTION_PLAN_PATH,
  search: { [LAW_KEY]: LL33_LAW, [BUILDING_KEY]: buildingId },
});
